import { baseDefaultContextProps } from '../../constants/props';
import { updateAssociationObject } from '../../data/api/associationsApi';
import { getObject } from '../../data/api/crmV3Api';
import { fetchPlaybooks, fetchRecommendedPlaybooks } from '../../data/api/playbooksApi';
import { fetchCardProperties, fetchExternalOptions, fetchPropertiesDetails, validateProperty } from '../../data/api/propertiesApi';
import { fetchRenderedContent, fetchUnrenderedContent, searchSnippets } from '../../data/api/snippetsApi';
export const defaultCrmObjectPreviewModalContextProps = Object.assign({}, baseDefaultContextProps, {
  crmObjectType: 'contact',
  activeObjectId: '',
  onClose: () => undefined,
  apiWrapper: {
    snippets: {
      fetchRenderedContent,
      fetchUnrenderedContent,
      searchSnippets
    },
    playbooks: {
      fetchPlaybooks,
      fetchRecommendedPlaybooks
    },
    fetchCardProperties,
    fetchPropertiesDetails,
    getObject,
    updateAssociationObject,
    validateProperty,
    fetchExternalOptions
  },
  extensionComponents: [],
  updateCrmObjectCallback: undefined,
  prosemirrorTrackerProperties: undefined,
  hubspotUserId: 0
});